import {
  createContext,
  useContext,
  createSignal,
  createResource,
} from "solid-js";

import * as i18n from "@solid-primitives/i18n";
import { urlParams } from "../store/UrlParameters";

const TranslatorContext = createContext();
const supportedLocales = ["en-us", "es-es", "us-en-ms", "us-es-ms"];

async function fetchDictionary(locale) {
  const dictModule = await import(`../locales/${locale}.js`);
  return i18n.flatten(dictModule.dict);
}

export const TranslatorProvider = (props) => {
  const [locale, setLocale] = createSignal("en-us");

  if (urlParams().lang && supportedLocales.includes(urlParams().lang)) {
    setLocale(urlParams().lang);
  }

  const [dict] = createResource(locale, fetchDictionary);

  const t = i18n.translator(() => dict() || {}, i18n.resolveTemplate);

  return (
    <TranslatorContext.Provider value={{ t, locale }}>
      {props.children}
    </TranslatorContext.Provider>
  );
};

export const useTranslator = () => useContext(TranslatorContext);
